export const URL_CHANGE = 'url_change';
export const SEARCH_STATE_CHANGE = 'search_state_change';
export const SEARCH_PAGE_LOADED = 'search_page_loaded';
